import React from 'react';
import { Box, Stack } from '@chakra-ui/react';
import { DocsNavigation } from '@types';
import { NavigationContent } from './navigation-content';
import { ClerkDocsLogo } from '@components/common';

export const SIDENAV_WIDTH = '300px';

type Props = {
  navigation: Array<DocsNavigation>;
};

export function DocsSidenav({ navigation }: Props): JSX.Element {
  return (
    <Box
      as="aside"
      pos="fixed"
      display={{ base: 'none', lg: 'block' }}
      h="100vh"
      w={SIDENAV_WIDTH}
      borderRight="1px solid"
      borderColor="var(--borderColor)"
      bg="var(--bodyBg)"
      paddingLeft={4}
      paddingTop={8}
      top="0"
      overflowY="auto"
    >
      <Stack spacing={0.5} h="full">
        <Box px={3}>
          <ClerkDocsLogo />
        </Box>

        <NavigationContent navigation={navigation} />
      </Stack>
    </Box>
  );
}
